import React, { useState } from 'react';
import { Grid, Dialog, DialogContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const Img = styled('img')({
  width: '100%',
  height: 'auto',
  cursor: 'pointer',
});

const PatientImages = (props) => {
  const { formData } = props;
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleClickOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
    {formData?.length ? <><Typography variant="h3" sx={{ fontSize: "22px" }}>Patient Images</Typography><Grid container spacing={2}>
        {formData?.slice(0, 4)?.map((image, index) => (
          <Grid item xs={12} sm={6} md={3} key={image?.id}>
            <Img
              src={image?.image_url}
              alt={`Patient ${index}`}
              sx={{ height: "200px", maxHeight: 200, maxWidth: '100%', objectFit: 'cover' }}
              onClick={() => handleClickOpen(image?.image_url)} />
          </Grid>
        ))}
      </Grid><Dialog open={open} onClose={handleClose}>
          <DialogContent>
            <Img src={selectedImage} alt="Selected" />
          </DialogContent>
        </Dialog></> :
      <Typography variant="h3"  sx={{fontWeight: "bold", fontSize: "22px", textAlign: "center" }}>No Images Available</Typography>
      }
    </>
  );
};

export default PatientImages;